import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Progress from "../Home/Progress";
import Verify from "../../Assets/images/verii.png";
import Identify from "../../Assets/images/veri.png";
import Wallet from "../../Assets/images/wa.png";
import Line from "../../Assets/images/Line.png";
import StartComp from "./StartComp";
import { UserContext } from "../../Context/UserContext";

function Start({ kycData }) {
  const { userDetails } = useContext(UserContext);
  const user = userDetails || {};
  const navigate = useNavigate();

  const kycPercentage = kycData?.kycPercentage ?? 0;
  const bvnVerified = kycData?.bvnVerified ?? false;
  const identityVerified = kycData?.identityVerified ?? false;
  const accountLinked = kycData?.accountLinked ?? false;

  const handleContainerClick = () => {
    navigate("/settings", { state: { activeTab: 2 } });
  };

  return (
    <div 
      onClick={handleContainerClick}
      className="p-5 rounded-2xl border border-[#E6E6E7] bg-white h-full flex flex-col justify-center cursor-pointer"
    >
      <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
        <div className="flex items-center gap-2">
          <p className="text-[16px] font-bold text-[#1A1A1B]">
            Start with the basics -{" "}
          </p>
          <p className="text-[#808285] text-[14px]">Complete your KYC</p>
        </div>

        <div className="flex items-center gap-4 flex-1 max-w-md px-4">
          <div className="flex-1">
            <Progress value={kycPercentage} />
          </div>
          <p className="text-[#1A1A1B] text-[14px] whitespace-nowrap font-medium">
            {kycPercentage}% complete
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-2 overflow-x-auto pb-2">
        <div className="w-full md:flex-1 min-w-[150px]">
          <StartComp img={Verify} title="Verify BVN" sub={bvnVerified ? "Verified" : "Verify your BVN"} />
        </div>
        <div className="hidden md:block h-12 w-[1px] bg-[#E6E6E7] mx-2"></div>

        <div className="w-full md:flex-1 min-w-[150px]">
          <StartComp
            img={Identify}
            title="Identity verification"
            sub={identityVerified ? "Verified" : "Complete identification process"}
          />
        </div>
        <div className="hidden md:block h-12 w-[1px] bg-[#E6E6E7] mx-2"></div>

        <div className="w-full md:flex-1 min-w-[150px]">
          <StartComp
            img={Wallet}
            title="Link your bank"
            sub={accountLinked ? "Verified" : "Link your bank account"}
          />
        </div>
      </div>
    </div>
  );
}

export default Start;
